import type { ExternalTableSchema } from '@packages/table-builder';

export const brokerageAccountDashboardTable: ExternalTableSchema = {
  metadata: {
    title: 'Brokerage Account Opening',
    entity: 'brokerage-account-dashboard',
  },
  dataSource: {
    endpoint: '/api/customer/api/app/participant-broker-account/account-opening-dashboard',
    method: 'GET',
    rowIdField: 'companyId',
    requestParams: {
      CompanyIds: 'filters.companyIds',
      BrokerStatusIds: 'filters.brokerStatusIds',
      BrokerIds: 'filters.brokerIds',
    },
    filters: [
      {
        name: 'companyIds',
        placeholder: 'Company',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/participant-broker-account/company-list',
          labelField: 'companyName',
          valueField: 'id',
        },
      },
      {
        name: 'brokerStatusIds',
        placeholder: 'Broker Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/participant-broker-account/broker-status-list',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
      {
        name: 'brokerIds',
        placeholder: 'Broker',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/broker/options',
          labelField: 'name',
          valueField: 'companyId',
        },
      },
    ],
  },
  columns: [
    { field: 'companyName', header: 'Company Name', type: 'text', width: 100 },
    {
      field: 'brokerStatus',
      header: 'Broker Status',
      type: 'badge',
      width: 180,
      align: 'center',
      badge: {
        statusMap: { Active: 'success', Inactive: 'warning', Suspended: 'error' },
      },
    },
    {
      field: 'employeeCount',
      header: 'Count of Employee Id',
      type: 'text',
      width: 250,
      align: 'center',
      aggregate: { fn: 'sum' },
    },
  ],
  actions: {
    row: [{ id: 'VIEW_DETAILS_BROKERAGE_ACCOUNT_DASHBOARD', label: 'View Details' }],
  },
  features: {
    pagination: { mode: 'none' },
    columnPreferences: { persistenceKey: 'Brokerage Account Dashboard', resizable: true, reorderable: true },
    groupBy: {
      fields: ['companyName'],
      expandMode: 'expanded',
      hideGroupedColumn: false,
      groupHeader: { showCount: true },
    },
  },
};
